/**
 * Returns true if the object has a given property, even if that property is falsy.
 * @param {Object} obj
 * @param {string} propertyName
 * @returns {boolean}
 */
export const objectHas = (obj, propertyName) => {
  while (obj) {
    if (Object.getOwnPropertyDescriptor(obj, propertyName)) {
      return true;
    }

    obj = Object.getPrototypeOf(obj);
  }

  return false;
};